var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.098,
    height: 20.093,
    viewBox: "0 0 20.098 20.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(5,25,47,0.32);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.067)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.936 5.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.412 0.108)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0.258 0.258)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.067)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.881,6.578a11.454,11.454,0,0,0-2.47-3.883A11.189,11.189,0,0,0,13.557.274a3.156,3.156,0,0,0-3.348.71L7.126,4.052a3.141,3.141,0,0,0-.655,3.483c.162.364.338.72.526,1.064L.23,15.365a.785.785,0,0,0-.23.555v3.454a.785.785,0,0,0,.785.785H4.239a.785.785,0,0,0,.785-.785V17.962H6.438a.785.785,0,0,0,.785-.785V15.764H8.636a.785.785,0,1,0,0-1.57h-2.2a.785.785,0,0,0-.785.785v1.413H4.239a.785.785,0,0,0-.785.785V18.59H1.57V16.246L8.532,9.284a.785.785,0,0,0,.116-.962A12.705,12.705,0,0,1,7.905,6.9a1.563,1.563,0,0,1,.328-1.732L11.317,2.1A1.584,1.584,0,0,1,13,1.741,9.612,9.612,0,0,1,16.3,3.808,9.878,9.878,0,0,1,18.42,7.152a1.559,1.559,0,0,1-.352,1.676l-3.12,3.106a1.581,1.581,0,0,1-1.728.337,10.191,10.191,0,0,1-1.413-.721.785.785,0,0,0-.821,1.338,11.767,11.767,0,0,0,1.631.832,3.146,3.146,0,0,0,3.438-.674l3.12-3.106A3.128,3.128,0,0,0,19.881,6.578Z",
    transform: "translate(0 -0.067)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8c2444d351efdf68a3183f5f13f003c6.svg";
export { ForwardRef as ReactComponent };